import { makeRequest } from '../../../lib/api';
import {
  CreateCardTypeRequest, UpdateCardTypeRequest, DeleteAndRestoreCardTypeRequest,
  GetCardTypePositionsRequest, UpdateCardTypePositionRequest, DeleteAndRestoreCardTypePositionRequest,
  CreateCardTypePositionRequest,
} from '../api/cardReference';

const SERVICE_CARDS_TYPES_PATH = '/v1/service_cards/types';
const SERVICE_CARDS_POSITIONS_PATH = '/v1/service_cards/types/service_positions';

class serviceCardController {
  // Вернуть список всех типов сервисных карт
  getServiceCardsTypes = (showDeleted = false) => {
    return makeRequest('get', `${ SERVICE_CARDS_TYPES_PATH }?showDeleted=${ showDeleted }`);
  };

  // Вернуть данные об указанном типе сервисных карт
  getServiceCardType = (id: string) => {
    return makeRequest('get', `${ SERVICE_CARDS_TYPES_PATH }/${ id }`);
  };

  // Добавить новый тип сервисных карт
  createServiceCardType = (data: CreateCardTypeRequest) => {
    return makeRequest('post', `${ SERVICE_CARDS_TYPES_PATH }`, data);
  };

  // Редактировать тип сервисных карт
  updateServiceCardType = (data: UpdateCardTypeRequest) => {
    return makeRequest('put', `${ SERVICE_CARDS_TYPES_PATH }/${ data.id }`, data);
  };

  // Пометить тип сервисных карт не активным
  deleteServiceCardType = (data: DeleteAndRestoreCardTypeRequest) => {
    return makeRequest('delete', `${ SERVICE_CARDS_TYPES_PATH }/${ data.id }`);
  };

  // Восстановить тип сервисных карт не активным
  restoreServiceCardType = (data: DeleteAndRestoreCardTypeRequest) => {
    return makeRequest('post', `${ SERVICE_CARDS_TYPES_PATH }/${ data.id }`);
  };

  // Вернуть список всех позиций по типу сервисной карты
  getServiceCardTypePositions = (data: GetCardTypePositionsRequest) => {
    return makeRequest('get', `${ SERVICE_CARDS_POSITIONS_PATH }?cardTypeId=${ data.cardTypeId }&showDeleted=${ data.showDeleted ?? false }`);
  };

  // Добавить новую позиции в тип сервисной карты
  createServiceCardTypePosition = (data: CreateCardTypePositionRequest) => {
    return makeRequest('post', `${ SERVICE_CARDS_POSITIONS_PATH }`, data);
  };

  // Редактировать позицию в сервисной карте
  updateServiceCardTypePosition = (data: UpdateCardTypePositionRequest) => {
    return makeRequest('put', `${ SERVICE_CARDS_POSITIONS_PATH }/${ data.id }`, data);
  };

  // Пометить позицию в сервисной карте не активной
  deleteServiceCardTypePosition = (data: DeleteAndRestoreCardTypePositionRequest) => {
    return makeRequest('delete', `${ SERVICE_CARDS_POSITIONS_PATH }/${ data.id }`);
  };

  // Восстановить позицию в сервисной карте
  restoreServiceCardTypePosition = (data: DeleteAndRestoreCardTypePositionRequest) => {
    return makeRequest('post', `${ SERVICE_CARDS_POSITIONS_PATH }/${ data.id }`);
  };
}

export default new serviceCardController();
